/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TemplateVisibility = {
    Dashboard: 'dashboard',
    Private: 'private',
    Global: 'global'
} as const;
export type TemplateVisibility = typeof TemplateVisibility[keyof typeof TemplateVisibility];


export function instanceOfTemplateVisibility(value: any): boolean {
    for (const key in TemplateVisibility) {
        if (Object.prototype.hasOwnProperty.call(TemplateVisibility, key)) {
            if (TemplateVisibility[key as keyof typeof TemplateVisibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TemplateVisibilityFromJSON(json: any): TemplateVisibility {
    return TemplateVisibilityFromJSONTyped(json, false);
}

export function TemplateVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateVisibility {
    return json as TemplateVisibility;
}

export function TemplateVisibilityToJSON(value?: TemplateVisibility | null): any {
    return value as any;
}

export function TemplateVisibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): TemplateVisibility {
    return value as TemplateVisibility;
}

